import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class YoutubeEmbed extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { embedId } = this.props;
    return (
      <>
        <div id="youtube__video" className="video__container-responsive">
          <iframe
            width="853"
            height="480"
            src={`https://www.youtube.com/embed/${embedId}`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Embedded youtube"
            className="video__iframe-responsive"
          />
        </div>
      </>
    );
  }
}

YoutubeEmbed.propTypes = {
  embedId: PropTypes.string.isRequired,
};
